module.exports = {"SeedPage.walmart.editMe":"Edit Me! Walmart English","SeedPage.samsclub.editMe":"Edit Me! samsclub English"}


//////////////////
// WEBPACK FOOTER
// ./components/specialist-page/src/lang/en.json
// module id = 1129
// module chunks = 0